import {FeatureGateTier} from 'common/report/constants';
import {CurrentProject} from 'common/report/model-resources/projects';

import {CLEAR_VALUE, UNSET_VALUE} from '../axis/constants';
import {CUSTOM_PRESET, DEFAULT_PRESET, PREFIX_PRESETS, SUFFIX_PRESETS} from './constants';

export function isMetricUnitsEnabled(project: CurrentProject) {
  const isEnterprise = project?.featureGateTier === FeatureGateTier.Enterprise;

  return isEnterprise;
}

// TODO: We likely need to just make preset a persistent setting instead of trying
// to infer it based on other pieces of state.
export const getToggleValue = (prefix?: string | null, suffix?: string | null) => {
  if ((prefix === CLEAR_VALUE && suffix === CLEAR_VALUE) || (prefix === UNSET_VALUE && suffix === UNSET_VALUE)) {
    return DEFAULT_PRESET;
  } else if (prefix && suffix) {
    return CUSTOM_PRESET;
  } else if (prefix && PREFIX_PRESETS.includes(prefix)) {
    return prefix;
  } else if (suffix && SUFFIX_PRESETS.includes(suffix)) {
    return suffix;
  }
  return CUSTOM_PRESET;
};
